import { useQuery } from '@apollo/client'
import { SEARCH_NAME, PERSON_ID } from '../infra/queries'
import _ from 'lodash'
import React, { useCallback, useState } from 'react'
import IndexView from '../presentation/IndexView'
import { LoadingSpinner } from '../presentation/spinners'
import ResultsView from '../presentation/ResultsView'
import { compareStrings } from '../lib/utils'

const IndexContainer = () => {
  const [nameSearch, setNameSearch] = useState('')
  const [debouncedName, setDebouncedName] = useState('')

  const handleNameSearchChange = n => {
    setNameSearch(n)
    debounceNameSearch(n)
  }

  // eslint-disable-next-line
  const debounceNameSearch = useCallback(_.debounce(name => setDebouncedName(name), 500), [])

  let results
  if (debouncedName.replace(/\s+/g, '').match(/\d{13}/)) {
    results = <ResultsContainer idSearch={debouncedName.replace(/\s+/g, '')} />
  } else if (debouncedName.length > 2) {
    results = <ResultsContainer nameSearch={debouncedName} />
  }

  return (
    <>
      <IndexView
        nameSearch={nameSearch}
        onNameSearchChange={handleNameSearchChange}
      />
      {results}
    </>
  )
}

const ResultsContainer = ({ nameSearch, idSearch }) => {
  const { loading, error, data } = useQuery(
    idSearch ? PERSON_ID : SEARCH_NAME,
    { variables: idSearch ? { idnumber: idSearch } : { searchText: nameSearch } }
  )

  if (loading) return <LoadingSpinner />
  if (error) throw error

  const results = data.person ? (data.person.darn ? [data.person] : []) : data.people

  const sortedResults = results.map(r => r.pubRep ? { ...r, staff: null } : r)
    .sort(
      (a, b) => compareStrings(a.surname.toLowerCase(), b.surname.toLowerCase()) ||
        compareStrings(a.firstname.toLowerCase(), b.firstname.toLowerCase())
    )

  return <ResultsView results={sortedResults} />
}

export default IndexContainer
